import React, { useState, useContext } from 'react'
import TextField from '@embracesbs/component-textfield'
import TextFieldWrapper from '@embracesbs/component-textfieldwrapper'
import { AuthRoleContext } from '../Auth/AuthRoleContext'
import { useApi } from '../../Hooks/useApi'
import { ButtonProps } from '@embracesbs/component-button2'

interface SecretFieldProps {
  fieldName: string
  secretName: string
  labelText: string
  value: string
  onChange: (name: string, value: string) => void
  isDisabled?: boolean
  style?: React.CSSProperties
  tenantId?: string
  regex?: string
  errorMessage?: string
}

const SecretField: React.FC<SecretFieldProps> = ({
  fieldName,
  secretName,
  labelText,
  value,
  onChange,
  isDisabled = false,
  style = {},
  tenantId,
  regex,
  errorMessage
}) => {
  const [secretValue, setSecretValue] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [showSecret, setShowSecret] = useState<boolean>(false)
  const { fetchApi } = useApi()
  const roles = useContext(AuthRoleContext)

  const hasValue = value && value.trim() !== ''
  const isMaskedValue = value && /^\*+$/.test(value)

  const regexPattern = !isMaskedValue && regex ? regex : undefined

  const toggleSecret = async () => {
    if (showSecret) {
      setShowSecret(false)
      return
    }

    if (!roles?.isAdmin || !tenantId) return

    setIsLoading(true)

    try {
      const response = await fetchApi({
        endpoint: `/api/tenant/${tenantId}/tenantsconfigurationruntime/secret/${secretName}`,
        method: 'GET'
      })

      setSecretValue(response.value)
      setShowSecret(true)
    } catch (error) {
      console.error(`Failed to fetch secret for ${fieldName}:`, error)
    } finally {
      setIsLoading(false)
    }
  }

  const buttonProps = !isDisabled
    ? {
        onClick: toggleSecret,
        iconName: isLoading ? 'EmailActionSync1' : showSecret ? 'ViewOff' : 'View1',
        isLoading,
        isDisabled: !hasValue,
        'aria-label': 'toggle-secret'
      }
    : undefined

  return (
    <TextFieldWrapper labelText={labelText} style={style}>
      <div style={{ position: 'relative' }}>
        <TextField
          value={showSecret ? secretValue : value}
          isDisabled={isDisabled}
          onChange={(e) => onChange(fieldName, e.target.value)}
          type={showSecret ? 'text' : 'password'}
          placeholder={'Enter value to update'}
          variant='default'
          hasRightIcon={true}
          buttonProps={buttonProps as ButtonProps}
          pattern={regexPattern}
        />
      </div>
    </TextFieldWrapper>
  )
}

export default SecretField
